import { observer } from "mobx-react-lite"
import React from "react"
import { useStores } from "../../models"
import styled from '~/ui/styled'
import EventList from "./event-list"
import ServerInfo from "./server-info"

interface Props {}

const Container = styled.View`
  flex: 1;
  background-color: #e3e6ec;
`

const WebSocketConsole: React.FC<Props> = () => {
  const { websocketStore: ws } = useStores()

  return (
    <Container>
      <ServerInfo error={ws.error} state={ws.stateText} uri={ws.url} />
      <EventList />
    </Container>
  )
}
export default observer(WebSocketConsole)
